import { render, staticRenderFns } from "./AdvertisingPyramid.vue?vue&type=template&id=bd107c88&scoped=true&"
import script from "./AdvertisingPyramid.vue?vue&type=script&lang=js&"
export * from "./AdvertisingPyramid.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisingPyramid.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AdvertisingPyramid.vue?vue&type=style&index=1&lang=css&"
import style2 from "./AdvertisingPyramid.vue?vue&type=style&index=2&id=bd107c88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd107c88",
  null
  
)

export default component.exports